var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"width":"288","height":"199","fill":"white","key":1}),React.createElement("rect",{"x":"16","width":"36","height":"199","fill":"#F2F2F2","key":2}),React.createElement("rect",{"x":"60","width":"36","height":"199","fill":"#F2F2F2","key":3}),React.createElement("rect",{"x":"104","width":"36","height":"199","fill":"#F2F2F2","key":4}),React.createElement("rect",{"x":"148","width":"36","height":"199","fill":"#F2F2F2","key":5}),React.createElement("rect",{"x":"192","width":"36","height":"199","fill":"#F2F2F2","key":6}),React.createElement("rect",{"x":"236","width":"36","height":"199","fill":"#F2F2F2","key":7})]);
}

Grid.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Grid;

Grid.default = Grid;
